
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRadarLongPulseIec as ObiRadarLongPulseIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-radar-long-pulse-iec.js';
 
 
 

 
 export const ObiRadarLongPulseIec = createComponent({
   react: React,
   tagName: 'obi-radar-long-pulse-iec',
   elementClass: ObiRadarLongPulseIecElement,
   events: {
     
   }
  });
 
 